@if (statusTags(); as statusTags) {
  @if (statusTags.length) {
    @for (statusKey of statusTags; track statusKey) {
      <span class="small tag {{ cssClasses[statusKey] }}">
        @if (icons[statusKey]) {
          <i class="fa {{ icons[statusKey] }}"></i>
        }
        {{ translations[statusKey] | translate }}
      </span>
    }
  } @else {
    <span>-</span>
  }
}
